import { render, staticRenderFns } from "./ShengCaipanList.vue?vue&type=template&id=ae2288b6&"
import script from "./ShengCaipanList.vue?vue&type=script&lang=js&"
export * from "./ShengCaipanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports